import type { Page } from '../../types';

const suspectedFraud: Page[] = [
  {
    pageType: 'question',
    title: 'Allegations of suspected fraud',
    name: 'suspected-fraud-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any allegations of suspected fraud to declare?',
        name: 'fraud_allegations_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Allegations of suspected fraud',
    name: 'suspected-fraud',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'fraud_allegations' },
        { title: 'Total Value', field: 'fraud_allegations_total' },
      ],
    },
    disabled: [
      {
        field: 'fraud_allegations_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'fraud_allegations',
        hint: 'If a value is not applicable, please enter 0',
        hideOptionalLabel: true,
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'fraud_allegations_total',
        hint: '',
        rules: {
          required: false,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'fraud_allegations_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default suspectedFraud;




